<kendo-dialog
*ngIf="active"
[width]="300"
[height]="450"
(close)="closeForm()"
title="{{ customMsgService.translate('novoTipoAvaria') }}"

>
<kendo-dialog-titlebar>
  <!-- {{ isNew ? "Add new product" : "Edit product" }}
   (valueChange)="onValueChange($event)" -->

</kendo-dialog-titlebar>

<form novalidate class="k-form" [formGroup]="editForm">


  <kendo-formfield orientation="horizontal">
    <kendo-label class="k-label" [for]="codigo"  [text]= "customMsgService.translate('codigo')"> </kendo-label>
    <kendo-textbox  [maxlength]="maxlength" formControlName="codigo" [clearButton]="true" #codigo required>
      <!-- <ng-template kendoTextBoxSuffixTemplate>
        <span class="counter">{{ counter }}</span>
      </ng-template>--> </kendo-textbox> 
    <kendo-formerror>  {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }}  {{ customMsgService.translate('codigo') }}   {{ customMsgService.translate('isRequired') }}</kendo-formerror>

</kendo-formfield>

  <kendo-formfield orientation="horizontal">
    <kendo-label class="k-label" [for]="pt"  [text]= "customMsgService.translate('pt')"> </kendo-label>
    <kendo-textbox (inputBlur)="inputBlur()" [maxlength]="maxlength"formControlName="pt" [clearButton]="true" #pt required> 
    
    </kendo-textbox>
    <kendo-formerror>  {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }}  {{ customMsgService.translate('pt') }}   {{ customMsgService.translate('isRequired') }}</kendo-formerror>

</kendo-formfield>

<kendo-formfield orientation="horizontal">
    <kendo-label [for]="en" [text]= "customMsgService.translate('en')"> </kendo-label>
    <kendo-textbox  [maxlength]="maxlength" formControlName="en" [clearButton]="true" #en > </kendo-textbox>
    <kendo-formerror>  {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }}  {{ customMsgService.translate('en') }}   {{ customMsgService.translate('isRequired') }}</kendo-formerror>

</kendo-formfield>



<kendo-formfield orientation="horizontal">
    <kendo-label [for]="fr"  [text]= "customMsgService.translate('fr')"> </kendo-label>
    <kendo-textbox [maxlength]="maxlength" formControlName="fr" [clearButton]="true" #fr > </kendo-textbox>
    <kendo-formerror>  {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }}  {{ customMsgService.translate('fr') }}   {{ customMsgService.translate('isRequired') }}</kendo-formerror>

</kendo-formfield>

<kendo-formfield orientation="horizontal">
  <kendo-label [for]="observacao"  [text]= "customMsgService.translate('obs')"> </kendo-label>
  <kendo-textarea formControlName="observacao" #observacao > </kendo-textarea>
 
</kendo-formfield>



</form>

<kendo-dialog-actions>
  <button kendoButton (click)="onCancel($event)"> {{ customMsgService.translate('cancel') }}</button>
  <button
    kendoButton
    themeColor="primary"
    [disabled]="!editForm.valid"
    (click)="onSave($event)"
  >
  {{ customMsgService.translate('saveChanges') }}
  </button>
</kendo-dialog-actions>
</kendo-dialog>